import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=a5c6101c&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=a5c6101c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c6101c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5c6101c')) {
      api.createRecord('a5c6101c', component.options)
    } else {
      api.reload('a5c6101c', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=a5c6101c&scoped=true&", function () {
      api.rerender('a5c6101c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4A8edZdtjbrFR/JS/comp/DocBox.vue"
export default component.exports